document.addEventListener('DOMContentLoaded', () => {
  const personalization = document.querySelector('#personalization[name="properties[Personalization]"]');
  if (!personalization) return;

  const label = document.querySelector('label[for="personalization"]');
  const parent = personalization.parentElement;
  label?.remove();
  personalization.remove();

  if (parent && parent.children.length === 0 && parent.textContent.trim() === '') parent.remove();

  const purchasePanel = document.createElement('div');
  purchasePanel.className = 'tic-purchase-panel';
  purchasePanel.innerHTML = `
    <div class="tic-product-benefits" aria-label="Product benefits">
      <div class="tic-product-benefit"><strong>Small-batch made</strong><br>Produced in Arizona</div>
      <div class="tic-product-benefit"><strong>Checked by hand</strong><br>Before it ships</div>
      <div class="tic-product-benefit"><strong>Questions?</strong><br>Contact the maker</div>
    </div>
    <div class="tic-product-note"><strong>Made-to-order item:</strong> Review the selected size, color, and options before adding it to your cart.</div>`;

  const productForm = document.querySelector('product-form-component, product-form');
  if (productForm) productForm.before(purchasePanel);
});
